<!-- ============================================================== -->
<!-- Fixed height Card Grid-->
<!-- ============================================================== -->
<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100%">
    <mat-card>
      <mat-card-content>
        <mat-card-title>Dialog Overview</mat-card-title>
        <mat-card-subtitle>The
          <code>&lt;MatDialog&gt;</code> service can be used to open modal dialogs with Material Design styling and animations.</mat-card-subtitle>
        <ol>
          <li>
            <mat-form-field>
              <input matInput [(ngModel)]="name" placeholder="What's your name?">
            </mat-form-field>
          </li>
          <li>
            <button mat-raised-button (click)="openDialog()">Pick one</button>
          </li>
          <li *ngIf="animal">
            You chose:
            <i>{{animal}}</i>
          </li>
        </ol>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<!-- ============================================================== -->
<!-- Basic Card Grid-->
<!-- ============================================================== -->